export default "__VITE_ASSET__BrfTcl63__"